import Helpers from '@intelingu/core/helpers/Helpers';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import withTranslation from "@intelingu/core/utils/withTranslation";

interface AccountRemovedProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class AccountRemoved extends Component<AccountRemovedProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    componentDidMount(): void {
        this.userStore.logout();
    }

    render() {
        const { t } = this.props;

        return <div className={'static-page'}>
            <div className={'alert alert-success'}>{ t('accountRemovedContent') }</div>
        </div>
    }

}
